import styled from "styled-components";
import { MainWrapper } from "@/lib/styles";

export const Container = styled(MainWrapper)<{
  $hasIndex?: boolean;
}>`
  padding: 3rem 0;
  display: ${({ $hasIndex }) =>
      $hasIndex ? "grid" : "block"};

  ${({ theme }) => theme.mediaQueries.laptop} {
    grid-template-columns: repeat(4,1fr);
  }
`;

export const Aside = styled.aside`
  grid-column: 1 / 2;

  ${({ theme }) => theme.mediaQueries.laptop} {
    padding-top: 2rem;
  }
`;

export const Content = styled.article<{
  $hasIndex?: boolean;
}>`
  margin: auto;

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: ${({ $hasIndex }) =>
      $hasIndex ? "100%" : "75%"};
  }

  grid-column: 2 / -1;
`;
